import { useContext, useState } from 'react';
import automobyApi from '../Api';
import { AppContext } from '../providers/appProvider';

export const useCurrency = () => {
  const { app } = useContext(AppContext);
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = async () => {
    try {
      setIsLoading(true);
      const response = await automobyApi.post('/currency/list');
      const currencies = response.data.currencies || [];
      setItems(currencies);
      app.setCurrencies(currencies);
      return currencies;
    } finally {
      setIsLoading(false);
    }
  };

  const update = async (currency) => {
    await automobyApi.post('/currency/update', currency);
    await fetch();
  };

  return {
    currencyService: {
      items,
      isLoading,
      fetch,
      update,
    },
  };
};
